import { signinGuestUuid } from '@/utils/actions';
import NoticePrimary2020 from '@svg/trip/notice_primary_20_20.svg';
import ArrowPrimary814 from '@svg/trip/arrow_primary_8_14.svg';

export default function TripGuestLoginPrompt({ tripId }: { tripId: string }) {
  return (
    <div className='mx-20pxr mb-20pxr'>
      <button
        className='flex items-center w-full bg-point-100 p-12pxr gap-10pxr rounded-6pxr'
        onClick={async () => {
          const guestUuid = await signinGuestUuid();

          sessionStorage.setItem(
            'needSaveSurvey',
            JSON.stringify({
              surveyId: tripId,
              guestUuid,
            }),
          );
          window.history.replaceState(null, '', '/myTravels');
          window.location.href = `${
            process.env.NEXT_PUBLIC_ZZIMCAR_URL
          }user/signin?redirectUrl=${window.location.origin}`;
        }}
      >
        <span className='py-2pxr'>
          <NoticePrimary2020 className='flex-none' />
        </span>
        <p className='flex-1 text-left text-gray-700 whitespace-pre-line body-14-r'>
          저장한 일정표를 다시 보고 싶다면,{'\n'}
          <span className='sub-heading-14-m text-info'>찜카 회원 로그인</span>을 해주세요.
        </p>
        <span className='relative w-20pxr h-20pxr'>
          <ArrowPrimary814 className='absolute flex-none -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2' />
        </span>
      </button>
    </div>
  );
}
